module.exports = __webpack_public_path__ + "static/media/6.67901715.jpg";